import state from "./moduleMailSentFailedStates";
import mutations from "./moduleMailSentFailedMutations";
import actions from "./moduleMailSentFailedActions";
import getters from "./moduleMailSentFailedGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}